export default __webpack_public_path__ + "static/media/Logo TP_mart.01bff5d6.png";